import axios from 'axios';

export const n2api = axios.create({
  baseURL: process.env.REACT_APP_N2_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// add a request interceptor
n2api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.location = '/login';
    }
    return Promise.reject(error);
  }
);